import React from 'react';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import {
  Box,
  Dialog,
  DialogContent,
  DialogTitle,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Typography,
} from '@mui/material';

import { useBodyScrollLock } from '@/hooks';

interface SportsAmericanFootballModalProps {
  open: boolean;
  onClose: () => void;
  onOptionClick: (opt: string) => void;
}

export const SportsAmericanFootballModal = ({
  open,
  onClose,
  onOptionClick,
}: SportsAmericanFootballModalProps) => {
  useBodyScrollLock(open);

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="xs"
      fullWidth
      PaperProps={{ sx: { borderRadius: 3, p: 1 } }}
    >
      <DialogTitle sx={{ display: 'flex', alignItems: 'center', gap: 1, pb: 1 }}>
        <Box
          sx={{
            width: 32,
            height: 32,
            borderRadius: '8px',
            bgcolor: 'action.hover',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: '1.25rem',
          }}
        >
          🏈
        </Box>
        <Typography variant="h6" fontWeight="bold">
          American Football
        </Typography>
      </DialogTitle>
      <DialogContent>
        <List>
          {[{ id: 'nfl', label: 'NFL' }].map((opt) => (
            <ListItem key={opt.id} disablePadding sx={{ mb: 0 }}>
              <ListItemButton
                onClick={() => onOptionClick(opt.id)}
                sx={{ borderRadius: 2, display: 'flex', justifyContent: 'space-between' }}
              >
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                  <Typography sx={{ fontSize: '1.25rem' }}>🏈</Typography>
                  <ListItemText primary={opt.label} primaryTypographyProps={{ fontWeight: 600 }} />
                </Box>
                <ChevronRightIcon color="action" />
              </ListItemButton>
            </ListItem>
          ))}
        </List>
      </DialogContent>
    </Dialog>
  );
};
